import { Building } from 'lucide-react'
import { useState } from 'react'

import { useGetRelevantBrokerages } from '../../hooks/needs_attention/useGetRelevantBrokerages'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import { type MultipleSelectedValuesFilter } from '../types'
import FilterManagementDropdown from './FilterManagementDropdown'
import { filterByLabelAndValueCallback } from './utils'

const BrokerageFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const { data: brokerages } = useGetRelevantBrokerages()

  const brokerageOptions: ComboboxFilterOption<string>[] =
    brokerages?.map((brokerage) => ({
      label: brokerage.name,
      value: brokerage.id,
    })) || []

  // If only one brokerage is available, don't show the filter.
  if (brokerageOptions.length === 1) {
    return <></>
  }

  const filteredOptions = brokerageOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Brokerages', options: filteredOptions || [] }]}
        placeholder='Search brokerages to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={brokerageOptions || []}
          noSelectionText='Brokerage'
          pluralIdentifier='brokerages'
        >
          <Building size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default BrokerageFilter
